// frontend/src/components/historias/EspecialidadSection.jsx
import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Button,
  Divider,
  Chip
} from '@mui/material';
import { formatDate } from '../../utils/dateUtils';

const EspecialidadSection = ({ seccion, historiaId, onUpdate }) => {
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">
          {seccion.especialidad.nombre}
        </Typography>
        <Chip 
          label={seccion.estado} 
          color={seccion.estado === 'En tratamiento' ? 'success' : 'warning'}
          size="small"
        />
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Motivo de Consulta
            </Typography>
            <Typography variant="body1">
              {seccion.motivo_consulta || 'No registrado'}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Historia de Enfermedad Actual
            </Typography>
            <Typography variant="body1">
              {seccion.historia_enfermedad_actual || 'No registrado'}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Examen Mental
            </Typography>
            <Typography variant="body1">
              {seccion.examen_mental || 'No registrado'}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Diagnóstico
            </Typography>
            <Typography variant="body1">
              {seccion.diagnostico || 'No registrado'}
            </Typography>
            {seccion.diagnostico_cie10 && (
              <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                CIE-10: {seccion.diagnostico_cie10}
              </Typography>
            )}
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Plan de Tratamiento
            </Typography>
            <Typography variant="body1">
              {seccion.plan_tratamiento || 'No registrado'}
            </Typography>
            {seccion.objetivos_terapeuticos && (
              <Box mt={2}>
                <Typography variant="subtitle2" color="textSecondary">
                  Objetivos Terapéuticos:
                </Typography>
                <Typography variant="body2">
                  {seccion.objetivos_terapeuticos}
                </Typography>
              </Box>
            )}
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Información Adicional
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={3}>
                <Typography variant="body2" color="textSecondary">
                  Fecha de Creación:
                </Typography>
                <Typography variant="body2">
                  {formatDate(seccion.fecha_creacion)}
                </Typography>
              </Grid>
              {seccion.num_sesiones_sugeridas && (
                <Grid item xs={6} sm={3}>
                  <Typography variant="body2" color="textSecondary">
                    Sesiones Sugeridas:
                  </Typography>
                  <Typography variant="body2">
                    {seccion.num_sesiones_sugeridas}
                  </Typography>
                </Grid>
              )}
              {seccion.frecuencia_sesiones && (
                <Grid item xs={6} sm={3}>
                  <Typography variant="body2" color="textSecondary">
                    Frecuencia:
                  </Typography>
                  <Typography variant="body2">
                    {seccion.frecuencia_sesiones}
                  </Typography>
                </Grid>
              )}
              {seccion.especialista && (
                <Grid item xs={6} sm={3}>
                  <Typography variant="body2" color="textSecondary">
                    Especialista:
                  </Typography>
                  <Typography variant="body2">
                    {seccion.especialista.usuario.nombre} {seccion.especialista.usuario.apellidos}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EspecialidadSection;